<template>
  <div class="onlineEducationPage" v-if="!this.showLoad">
    <h3>
      {{ baseInfo.name }} <span>--{{ baseInfo.typeName }}类</span>
    </h3>
    <p class="timeStyle" v-if="countDownText">
      已阅读时长:
      <span>{{ countDownText }}</span>
    </p>
    <p class="tit">
      课程简介: <span>(课程有效时长:{{ baseInfo.effectiveTime }}分钟) </span>
    </p>
    <p class="intro">{{ baseInfo.introduce }}</p>
    <p class="tit">课程内容:</p>
    <div class="infoDetail">
      <ul v-if="files.length > 0">
        <li class="clearfix flex" v-for="(item, index) in files" :key="index">
          <dl class="fl" @click="preview(item)">
            <dt>
              <van-image
                :src="
                  getFormat(item.fileName) == 'jpg' ||
                  getFormat(item.fileName) == 'png' ||
                  getFormat(item.fileName) == 'jpeg'
                    ? item.url
                    : getFormat(item.fileName) == 'pdf'
                    ? '' + baseUrl + 'searchImg/pdf.png'
                    : getFormat(item.fileName) == 'xlsx' ||
                      getFormat(item.fileName) == 'xls'
                    ? '' + baseUrl + 'searchImg/excel.png'
                    : getFormat(item.fileName) == 'mp3' ||
                      getFormat(item.fileName) == 'mp4' ||
                      getFormat(item.fileName) == 'avi' ||
                      getFormat(item.fileName) == 'rmvb' ||
                      getFormat(item.fileName) == 'mkv' ||
                      getFormat(item.fileName) == 'mov' ||
                      getFormat(item.fileName) == 'm4v' ||
                      getFormat(item.fileName) == 'rm' ||
                      getFormat(item.fileName) == 'wmv' ||
                      getFormat(item.fileName) == '3gp' ||
                      getFormat(item.fileName) == 'flv'
                    ? '' + baseUrl + 'searchImg/video.png'
                    : '' + baseUrl + 'searchImg/word.png'
                "
                fit="cover"
              />
            </dt>
            <dd class="dtName">{{ item.fileName }}</dd>
            <dd class="Mb">
              <span>{{ getMb(item.fileSize) }}</span>
            </dd>
          </dl>
          <div class="flex-one">
            <a
              href="javascript:void(0);"
              class="downloadBtn delBtn"
              @click="preview(item)"
              >查看</a
            >
            <a
              href="javascript:void(0);"
              class="downloadBtn"
              v-if="baseInfo.download"
              @click="downLoad(item)"
              >下载</a
            >
          </div>
        </li>
      </ul>
    </div>
    <van-popup
      v-model="videoViewShow"
      closeable
      close-icon="close"
      class="videoViewPicker"
      :close-on-click-overlay="false"
    >
      <video
        v-if="videoViewShow"
        :src="vUrl"
        autoplay
        controls
        loop
        class="mb10 mySelfVideo"
      ></video>
    </van-popup>
    <van-popup
      v-model="pdfViewShow"
      closeable
      close-icon="close"
      class="pdfViewPicker"
      :close-on-click-overlay="false"
    >
      <preview v-if="pdfViewShow" :selectFile="selectFile"></preview>
    </van-popup>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { getCurTime, intervalTime } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import preview from "@/components/common/pdfView";

export default {
  name: "onlineEducation",
  components: { preview },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      infoId: "", //内容的id
      baseInfo: {
        effectiveTime: "", //有效时长
        introduce: "", //课程简介
        name: "", //课程名
        phone: "", //联系方式
        source: "", //培训来源(in 公司内 ; out 公司外)
        trainer: "", //培训人
        trainingTime: "", //培训时间
        type: "", //课程分类
        typeName: "", //分类名称
        baseFiles: [],
      },
      selectFile: {},
      startTime: "",
      endTime: "",
      files: [],
      vUrl: "", //视频链接
      pdfUrl: "",
      pdfViewShow: false,
      videoViewShow: false,
      countDownTime: 0,
      countDownText: "", //已完成时长
      fristType: 0, //第一次到达规定时长
      countTimmer: null,
      readTimmer: null,
      clientType: getDeviceType(), //手机类型
      userAgentType: "",
    };
  },
  mounted() {
    let userAgent = window.navigator.userAgent.toLowerCase();
    // console.log(userAgent, "userAgent");
    this.userAgentType = userAgent.indexOf("dhoa") != -1 ? true : false;
    window.getCountTime = this.getCountTime; //app点击返回调用计算方法
    this.infoId = this.$route.query.commonId || "";
    this.startTime = getCurTime();
    this.startCount();
    this.getDetail();
    // this.startRead();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    //获取文件后缀名
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },
    getMb(Kb) {
      //计算附件大小
      let size = "";
      size = (Kb / 1024).toFixed(2) + "kB";
      return size;
    },
    preview(item) {
      let _this = this;
      const imgtype = ["gif", "png", "jpg", "jpeg", "jpe"];
      let curtype = item.url.substring(item.url.lastIndexOf(".") + 1);
      curtype = curtype.toLowerCase();
      let isImg = imgtype.find((item) => item == curtype);
      if (isImg) {
        let magnifyList = [];
        let _this = this;
        magnifyList.push(item.url);
        let data = {
          showImgs: magnifyList,
          swipercliclIndex: 0,
          swiperShow: true,
        };
        if (magnifyList.length > 0) {
          _this.$store.commit("setDataImgs", data);
        }
      } else if (curtype == "pdf") {
        this.selectFile = item;
        this.pdfViewShow = true;
      } else if (
        curtype == "mp3" ||
        curtype == "mp4" ||
        curtype == "avi" ||
        curtype == "rmvb" ||
        curtype == "mkv" ||
        curtype == "mov" ||
        curtype == "m4v" ||
        curtype == "rm" ||
        curtype == "wmv" ||
        curtype == "3gp" ||
        curtype == "flv"
      ) {
        _this.videoViewShow = true;
        _this.vUrl = item.url;
      } else {
        _this.download(item);
      }
    },
    getDetail() {
      let _this = this;
      this.setShowLoad(false); //加载状态，默认为true加载

      _this.$api.administration.administration.course
        .details(_this.infoId)
        .then((res) => {
          if (res.code == "1") {
            // _this.effectiveTime = res.data.effectiveTime;
            _this.baseInfo = res.data;
            _this.files = _this.baseInfo.baseFiles;
          } else {
            _this.$toast(res.msg);
          }
        });
    },
    //下载附件
    downLoad(data) {
      let _this = this;
      let StringJson = JSON.stringify(data);
      let params = {
        lessonId: _this.infoId,
        uid: _this.userinfo.id,
      };
      _this.$api.administration.administration.course
        .addDownload(params)
        .then((res) => {
          if (res.code == "1") {
            if (_this.userAgentType) {
              //判断页面是否在页面
              //在app
              //判断ua中是否含有和app端约定好的标识ezhouxing
              if (_this.clientType == "android") {
                //安卓
                window.android.getInfo(105, StringJson);
              } else {
                let dataArguments = {
                  url: data.url,
                  fileName: data.fileName,
                  twoArguments: "",
                };
                if (
                  _this.getFormat(data.fileName) == "jpg" ||
                  _this.getFormat(data.fileName) == "png" ||
                  _this.getFormat(data.fileName) == "jpeg"
                ) {
                  dataArguments.twoArguments = "picture";
                }
                window.webkit.messageHandlers.downLoad.postMessage(
                  JSON.stringify(dataArguments)
                );
              }
            } else {
              let alink = document.createElement("a");
              alink.href = data.url;
              alink.download = data.fileName; //图片名
              alink.click();
            }
          } else {
            _this.$toast(res.msg);
          }
        });
    },
    async getCountTime() {
      this.endTime = getCurTime();
      let _this = this;
      let startTime = _this.startTime;
      let endTime = _this.endTime;

      let effectiveTime = Number(_this.baseInfo.effectiveTime);
      let disTime = await intervalTime(startTime, endTime, "3");

      let params = {
        endTime: endTime,
        startTime: startTime,
        length: parseInt(disTime),
        lessonId: _this.infoId,
        uid: _this.userinfo.id,
      };
      if (disTime >= effectiveTime) {
        _this.$api.administration.administration.course
          .addRead(params)
          .then((res) => {
            if (res.code != "1") {
              _this.$toast(res.msg);
            }
          });
      }
    },
    startCount() {
      let _this = this;

      _this.countTimmer = setTimeout(function () {
        _this.countDownTime++;
        _this.countDownText = _this.getTime(_this.countDownTime);
        if (
          Number(_this.countDownTime) >=
          Number(_this.baseInfo.effectiveTime) * 60
        ) {
          _this.fristType++;

          if (_this.fristType == "1") {
            _this.getCountTime();
          }
        }

        _this.startCount();
      }, 1000);
    },
    startRead() {
      //每5分钟调用一次接口
      let _this = this;
      _this.readTimmer = setTimeout(function () {
        _this.getCountTime();
      }, 300000);
    },
    getTime(time) {
      // 转换为式分秒
      let h = parseInt((time / 60 / 60) % 24);
      h = h < 10 ? "0" + h : h;
      let m = parseInt((time / 60) % 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt(time % 60);
      s = s < 10 ? "0" + s : s;
      // 作为返回值返回
      return h + "小时" + m + "分" + s + "秒";
    },
  },
  beforeDestroy() {
    this.getCountTime();
    clearInterval(this.countTimmer);
    clearInterval(this.readTimmer);
    this.countTimmer = null;
    this.readTimmer = null;
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less" scoped>
.onlineEducationPage {
  height: 100%;
  color: #666;
  h3 {
    line-height: 45px;
    font-size: 18px;
    text-align: center;
    color: #333;
    span {
      font-weight: none;
      font-size: 15px;
      color: #666;
    }
  }
  .intro {
    padding: 0 16px;
    text-align: justify;
    font-size: 15px;
    text-indent: 2em;
  }
  p.tit {
    position: relative;
    padding: 0 16px 0 22px;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    color: #2581d6;
    font-weight: 700;
    margin-top: 15px;
    span {
      color: #666;
      font-weight: 400;
    }
  }
  > p.tit:before {
    content: "";
    position: absolute;
    width: 3px;
    height: 15px;
    background: #2581d6;
    top: 14px;
    left: 16px;
  }
  .timeStyle {
    padding: 0 16px;
    text-align: right;
    font-size: 13px;
    span {
      font-size: 16px;
    }
  }
  .infoDetail {
    padding: 0 16px;
    width: 100%;
    margin-top: 10px;

    li {
      width: 100%;
      min-height: 40px;
      margin: 15px 0;

      dl {
        width: 80%;
        position: relative;

        dt {
          display: block;
          width: 40px;
          height: 40px;
          background-color: #f6f6f6;
          position: absolute;
          .van-image {
            width: 100%;
            height: 100%;
          }
        }

        dd {
          display: block;
          font-size: 10px;
          color: #999;
          position: absolute;
        }

        dd.dtName {
          width: 80%;
          overflow: hidden;
          white-space: nowrap;
          /*设置内容不换行*/
          text-overflow: ellipsis;
          font-size: 12px;
          color: #666;
          top: 0px;
          left: 50px;
        }
        dd.Mb {
          top: 17px;
          left: 50px;
        }
      }
    }

    a {
      display: block;
      font-size: 12px;
      color: #35c476;
      width: 30px;
      height: 30px;
      line-height: 30px;
    }
    a.delBtn {
      color: #f34646;
    }
  }
  .flex {
    display: flex;
  }
  .flex-one {
    flex: 1;
    a {
      display: inline-block;
      width: 50%;
      text-align: center;
    }
  }
  .pdfViewPicker {
    width: 100%;
    height: 90%;
    padding-top: 20px;
  }
  .videoViewPicker {
    width: 100%;
    height: 35%;
    padding-top: 50px;
  }
  .mySelfVideo {
    width: 100%;
    height: 95%;
    position: relative;

    .video-wrapper {
      height: 100%;
      padding-bottom: 10% !important;
    }
    .vjs-big-play-button {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }
}
</style>